import { render } from "./Shop.vue?vue&type=template&id=fb7a1236"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
script.render = render

export default script